import type { FC } from "react";
import "react-calendar/dist/Calendar.css";
import type { PriceValue } from "../../../misc/price";
import PriceInput from "./PriceInput";
import "./ProductOptionEdit.scss";

interface Props {
  readonly day: string;
  readonly value: Exclude<PriceValue, "INVALID">;
  readonly disabled?: boolean;
  onChange: (value: Exclude<PriceValue, "INVALID">) => void;
}

const DayInput: FC<Props> = ({ day, value, disabled, onChange }) => {
  return (
    <PriceInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      buttonIdSuffix={day}
      testId={`day-price-${day}`}
    />
  );
};

export default DayInput;
